/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Type of the source: reading or setting.
 */
export const SourceType = {
  Reading: "reading",
  Setting: "setting",
} as const;
/**
 * Type of the source: reading or setting.
 */
export type SourceType = ClosedEnum<typeof SourceType>;

/**
 * The value kind for aggregation selection.
 */
export const QueryTrendSourceValueKind = {
  Number: "number",
  Boolean: "boolean",
  Enum: "enum",
  Schedule: "schedule",
  Sequence: "sequence",
  String: "string",
} as const;
/**
 * The value kind for aggregation selection.
 */
export type QueryTrendSourceValueKind = ClosedEnum<
  typeof QueryTrendSourceValueKind
>;

/**
 * A source to query with its type and value kind for aggregation selection.
 */
export type QueryTrendSource = {
  /**
   * The source ID.
   */
  id: string;
  /**
   * Type of the source: reading or setting.
   */
  sourceType: SourceType;
  /**
   * The value kind for aggregation selection.
   */
  valueKind: QueryTrendSourceValueKind;
};

/** @internal */
export const SourceType$inboundSchema: z.ZodNativeEnum<typeof SourceType> = z
  .nativeEnum(SourceType);
/** @internal */
export const SourceType$outboundSchema: z.ZodNativeEnum<typeof SourceType> =
  SourceType$inboundSchema;

/** @internal */
export const QueryTrendSourceValueKind$inboundSchema: z.ZodNativeEnum<
  typeof QueryTrendSourceValueKind
> = z.nativeEnum(QueryTrendSourceValueKind);
/** @internal */
export const QueryTrendSourceValueKind$outboundSchema: z.ZodNativeEnum<
  typeof QueryTrendSourceValueKind
> = QueryTrendSourceValueKind$inboundSchema;

/** @internal */
export const QueryTrendSource$inboundSchema: z.ZodType<
  QueryTrendSource,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: types.string(),
  source_type: SourceType$inboundSchema,
  value_kind: QueryTrendSourceValueKind$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "source_type": "sourceType",
    "value_kind": "valueKind",
  });
});
/** @internal */
export type QueryTrendSource$Outbound = {
  id: string;
  source_type: string;
  value_kind: string;
};

/** @internal */
export const QueryTrendSource$outboundSchema: z.ZodType<
  QueryTrendSource$Outbound,
  z.ZodTypeDef,
  QueryTrendSource
> = z.object({
  id: z.string(),
  sourceType: SourceType$outboundSchema,
  valueKind: QueryTrendSourceValueKind$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    sourceType: "source_type",
    valueKind: "value_kind",
  });
});

export function queryTrendSourceToJSON(
  queryTrendSource: QueryTrendSource,
): string {
  return JSON.stringify(
    QueryTrendSource$outboundSchema.parse(queryTrendSource),
  );
}
export function queryTrendSourceFromJSON(
  jsonString: string,
): SafeParseResult<QueryTrendSource, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => QueryTrendSource$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'QueryTrendSource' from JSON`,
  );
}
